<template>
  <v-container class="login-container" fluid fill-height>
    <v-row align="center" justify="center" style="min-height: 80vh;">
      <v-col cols="12" sm="8" md="6" lg="4" class="text-center">
        <v-card class="pa-8 glass-card" elevation="0" rounded="xl">
          <v-avatar size="80" class="mb-6 avatar-shadow" color="white">
            <v-icon size="50" color="pink-darken-2">mdi-calendar-check</v-icon>
          </v-avatar>
          <v-card-title class="text-h4 font-weight-bold d-block text-primary-dark mb-2">
            NPTU-Booking
          </v-card-title>
          <v-card-subtitle class="text-body-1 mt-2 text-grey-darken-2" style="white-space: normal;">
            ลงชื่อเข้าใช้งานด้วย Email มหาวิทยาลัย <br />
            (@{{ ORGANIZATION_EMAIL_DOMAIN }})
          </v-card-subtitle>

          <v-divider class="my-6 border-opacity-25"></v-divider>

          <v-row justify="center">
            <v-col cols="12" sm="10">
              <v-btn v-if="!isAuthenticated" @click="login" color="white" class="login-btn text-pink-darken-2 text-none"
                block size="x-large" elevation="3" rounded="pill">
                <v-icon start color="red">mdi-google</v-icon>
                <span class="font-weight-medium">Login with Google</span>
              </v-btn>

              <v-progress-circular v-if="isLoadingUser" indeterminate color="primary"
                class="mt-4"></v-progress-circular>
            </v-col>
          </v-row>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>
<script setup>
import { ref, reactive } from "vue";
import { useAuth } from "@/composable";

const {
  user,
  isAuthenticated,
  login,
  logout,
  snackbar,
  snackbarMessage,
  snackbarColor,
  isLoadingUser,
} = useAuth();

const ORGANIZATION_EMAIL_DOMAIN = "ptu.ac.th";
</script>

<style scoped>
.login-container {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
}

.glass-card {
  background: rgba(255, 255, 255, 0.75) !important;
  backdrop-filter: blur(20px);
  -webkit-backdrop-filter: blur(20px);
  border: 1px solid rgba(255, 255, 255, 0.6) !important;
  box-shadow: 0 16px 40px 0 rgba(31, 38, 135, 0.15) !important;
  transition: transform 0.3s ease, box-shadow 0.3s ease;
}

.glass-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 20px 48px 0 rgba(31, 38, 135, 0.2) !important;
}

.avatar-shadow {
  box-shadow: 0 8px 24px rgba(216, 27, 96, 0.25) !important;
}

.text-primary-dark {
  color: #d81b60 !important;
}

.login-btn {
  transition: all 0.2s ease;
  font-family: 'Inter', sans-serif;
  letter-spacing: 0.5px;
}

.login-btn:hover {
  transform: scale(1.02);
  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.15) !important;
}

.text-center {
  text-align: center;
}

.text-h4,
.text-sm-h3,
.text-body-1,
.text-sm-h6 {
  white-space: normal !important;
  overflow: visible !important;
}

h1,
h4 {
  white-space: normal !important;
  overflow: visible !important;
}
</style>
